import Vue from 'vue';
import InstantSearch from 'vue-instantsearch';
import Algolia from './Algolia.vue';
import Deals from './Deals.vue';

Vue.use(InstantSearch);

function init() {
    document.body.scrollTop = sessionStorage.scroll;
}

function scrollPosition() {
    const scrollpos = document.body.scrollTop;

    if (typeof Storage !== 'undefined') {
        if (sessionStorage.scroll) {
            sessionStorage.scroll = scrollpos;
        } else {
            sessionStorage.scroll = 0;
        }
    }
}

const searchNodes = document.querySelectorAll('.roam-search');

if (searchNodes.length > 0) {
    searchNodes.forEach((node) => {
        const searchTemplate = node.classList.contains('roam-deals-search') ? Deals : Algolia;

        new Vue({
            data() {
                return {
                    categories: [
                        {
                            label: 'All',
                            value: '',
                        },
                        ...JSON.parse(node.dataset.categories),
                    ],
                    hub: node.dataset.hub,
                };
            },
            render: (h) => h(searchTemplate),
        }).$mount(node);
    });

    window.onscroll = scrollPosition;
    window.onload = init;
}
